import React, { useEffect } from "react";
import styles from "./ProfilePage.module.css";
import Header from "../../Header/Header";
import { useNavigate } from "react-router-dom";
import { useProfile } from "../../../contexts/ProfileContext";
import config from "../../../config";
const ProfilePage = () => {
    const navigate = useNavigate();
    const { profileData, fetchProfile } = useProfile();

    useEffect(() => {
        // Fetch profile data when component loads if not already present
        if (!profileData) {
            fetchProfile();
        }
    }, [profileData]);

    return (
        <>
            <Header title="View Profile" />

            <main className={styles.profilePage}>
                <button onClick={() => navigate("/settings")} className={styles.backButton}>
                    <img
                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/a3f4cc250003129920e6524c05797ad012534f9211075301316abedf7660e59c?placeholderIfAbsent=true&apiKey=355710932fa240f1a51c362a9b36f625"
                        alt=""
                        className={styles.backIcon}
                    />
                    <span className={styles.backText}>Back to settings</span>
                </button>

                <div className={styles.profileContainer}>
                    <section className={styles.profileCard}>
                        {profileData?.profile_pic ? (
                            <img
                                src={`${config.get("API_URL")}${profileData.profile_pic}`}
                                alt={`Profile picture of ${profileData?.first_name || "User"}`}
                                className={styles.profileImage}
                            />
                        ) : (
                            <div className="tw-w-32 tw-h-32 tw-rounded-full tw-bg-red-500 tw-flex tw-items-center tw-justify-center tw-text-white tw-font-bold tw-text-5xl">
                                {profileData?.first_name?.charAt(0).toUpperCase()}
                                {profileData?.last_name?.charAt(0).toUpperCase()}
                            </div>
                        )}
                        <div className={styles.profileInfo}>
                            <h2 className={styles.profileLabel}>Name:</h2>
                            <p className={styles.profileName}>
                                {profileData?.first_name} {profileData?.last_name}
                            </p>
                        </div>
                    </section>

                    <div className={styles.verificationButton}>
                        <button className={styles.buttonContent}>
                            <span className={styles.buttonText}>Get Verified!</span>
                            <img
                                src="https://cdn.builder.io/api/v1/image/assets/TEMP/879f10cc3f6bc2191331d7641b653d611f1ab3119c12d69b4944156a76ee53b5?placeholderIfAbsent=true&apiKey=355710932fa240f1a51c362a9b36f625"
                                alt=""
                                className={styles.buttonIcon}
                            />
                        </button>
                    </div>

                    <section className={styles.profileDetails}>
                        {/* First Name */}
                        <div className={styles.profileDetail}>
                            <div className={styles.detailContent}>
                                <h3 className={styles.detailLabel}>First Name:</h3>
                                <p className={styles.detailValue}>{profileData?.first_name}</p>
                            </div>
                        </div>
                        {/* Last Name */}
                        <div className={styles.profileDetail}>
                            <div className={styles.detailContent}>
                                <h3 className={styles.detailLabel}>Last Name:</h3>
                                <p className={styles.detailValue}>{profileData?.last_name}</p>
                            </div>
                        </div>
                        {/* Email */}
                        <div className={styles.profileDetail}>
                            <div className={styles.detailContent}>
                                <h3 className={styles.detailLabel}>Email:</h3>
                                <p className={styles.detailValue}>{profileData?.email}</p>
                            </div>
                        </div>
                        {/* Phone Number */}
                        <div className={styles.profileDetail}>
                            <div className={styles.detailContent}>
                                <h3 className={styles.detailLabel}>Phone Number:</h3>
                                <p className={styles.detailValue}>{profileData?.phone}</p>
                            </div>
                        </div>
                    </section>
                </div>

                <button onClick={() => navigate("/account")} className={styles.editProfileButton}>
                    <span className={styles.editProfileText}>Edit profile</span>
                </button>
                <br />
            </main>
        </>
    );
};

export default ProfilePage;
